import { useDefinedQuery } from '@/hooks/useDefinedQuery'
import type { QueryDef } from '@/hooks/useDefinedQuery'
import { getDashboardStats } from '@/services/api/dashboard'
import type { CollectionStats } from '@/types'

/**
 * Fraction (0–100) of available unique cards/variants the user owns. Returns 0
 * when stats are missing or the catalog reports nothing available (avoids NaN).
 */
export function collectionCompletionPercentage(stats: CollectionStats | undefined): number {
  if (!stats || stats.totalAvailable <= 0) return 0
  return (stats.uniqueCards / stats.totalAvailable) * 100
}

const dashboardQueries = {
  stats: {
    queryKey: (showHidden: boolean, collapseVariants: boolean) =>
      ['dashboardStats', showHidden, collapseVariants] as const,
    queryFn: (showHidden: boolean, collapseVariants: boolean) => getDashboardStats(showHidden, collapseVariants),
    staleTime: 1000 * 60 * 2, // 2 minutes
    auth: 'required',
  } satisfies QueryDef<Awaited<ReturnType<typeof getDashboardStats>>, [boolean, boolean]>,
}

export function useDashboardStats(showHidden: boolean, collapseVariants: boolean) {
  return useDefinedQuery(dashboardQueries.stats, showHidden, collapseVariants)
}
